var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4143 1C9.90855 1.00001 9.4347 1.24743 9.14571 1.66248L4.47245 8.37338C3.5949 9.6336 3.20377 11.1691 3.3715 12.6956L3.73087 15.9659C3.88443 17.3633 4.98152 18.4703 6.37758 18.6364L8.71542 18.9144C10.5007 19.1268 12.3108 18.9427 14.0168 18.3753C15.2109 17.9781 16.1674 17.0718 16.6282 15.9008L18.515 11.1059C18.6062 10.8739 18.6693 10.6319 18.7028 10.3849C18.9947 8.23468 17.0518 6.45325 14.9349 6.93025L10.6304 7.90017L11.9113 2.9318C12.1635 1.95339 11.4246 0.999978 10.4143 1Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFill);
export default __webpack_public_path__ + "static/media/like-fill.74d517b70b247285aacfff59939af2cf.svg";
export { ForwardRef as ReactComponent };